import { render, staticRenderFns } from "./CopyVenueForm.vue?vue&type=template&id=0fa0577d"
import script from "./CopyVenueForm.vue?vue&type=script&lang=ts"
export * from "./CopyVenueForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports